"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("../shapes/Spinner"));

var _colors = require("../colors");

var getSpinnerSizeString = function getSpinnerSizeString(spinnerSize) {
  return spinnerSize >= 72 ? 'large' : spinnerSize >= 38 ? 'medium' : 'small';
};

var CarouselLoading =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(CarouselLoading, _PureComponent);

  function CarouselLoading() {
    (0, _classCallCheck2["default"])(this, CarouselLoading);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CarouselLoading).apply(this, arguments));
  }

  (0, _createClass2["default"])(CarouselLoading, [{
    key: "render",
    value: function render() {
      var size = this.props.size;
      var spinnerSize = size / 3;
      return _react["default"].createElement("div", {
        className: "item active",
        style: {
          backgroundColor: _colors.silver,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, _react["default"].createElement("div", {
        style: {
          height: spinnerSize
        }
      }, _react["default"].createElement(_Spinner["default"], {
        size: getSpinnerSizeString(spinnerSize)
      })));
    }
  }]);
  return CarouselLoading;
}(_react.PureComponent);

exports["default"] = CarouselLoading;
CarouselLoading.propTypes = {
  size: _propTypes["default"].number
};